import React, {useState} from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import VideoIcon from "@material-ui/icons/VideoLibrary";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import { Button, ButtonGroup, Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
Grid, TextField } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import learningActions from "../../../redux/actions/learning";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Nombre",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "Descripción",
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "Fecha creación",
  },
  {
    id: "url",
    numeric: false,
    disablePadding: false,
    label: "Video",
  },
  
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function Tabla() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("datetimeCreated");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const [rows, setRows] = React.useState([]);
  const learning = useSelector((state) => state.learning);
  const [view, setView] = React.useState(false);
  const [urlVideo, setUrlVideo] = React.useState("");
  const [update, setUpdate] = React.useState(false);
  const [error, setError] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  React.useEffect(() => {
    
    if (learning.learning.data) {
      setRows(learning.learning.data);
    }
  }, [learning.learning.data]);

  async function handleUpload(e,id) {
    e.preventDefault();
    const formData = new FormData();
    formData.append("id", id);
    console.log(id);
      try {
      const response = await dispatch(learningActions.viewDisplay(formData));
      setUrlVideo(response);
      setIsUploaded(true);
      setIsUploading(false);
      if (view){
        setView(false);
      }else {
        setView(true);
      }
    } catch (err) {
      setError(err.message);
      setIsUploading(false);
      handleClose();
    }
}

function stableSort(array, comparator) {
  
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const handleClose = () => {
  setView(false);
};

async function handleStatus(e,status,id) {
  e.preventDefault();
  const formData = new FormData();
  formData.append("status", status === 0 ? 1 : 0);
  formData.append("id", id);
    try {
    const response = await dispatch(learningActions.updateLearning(formData));
    setIsUploaded(true);
    setIsUploading(false);
    const start = async () => {
      dispatch(learningActions.fetchLearning());
    };
    start();
  } catch (err) {
    setError(err.message);
    setIsUploading(false);
    handleClose();
  }
}

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    console.log(rows);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
            {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(index);

                  return (
                    <TableRow
                      hover
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                    >
                      <StyledTableCell align="left">
                      {row.title}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                      {row.description}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                      {row.createdAt
                      ? new Intl.DateTimeFormat("es-CL", {
                        year: "numeric",
                        month: "numeric",
                        day: "2-digit",
                        hour: "numeric",
                        minute: "numeric"
                      }).format(new Date(row.createdAt))
                    : "-"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                      <ButtonGroup size="small" variant="contained">
                          <Button
                            id={row._id}
                            value={row.url}
                            onClick={(e) => handleUpload(e,row._id)}
                            color="primary"
                          >
                            <VideoIcon />
                          </Button>
                        </ButtonGroup>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage={"Filas por página"}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to === -1 ? count : to} de ${
              count !== -1 ? count : `más de ${to}`
            }`
          }
          rowsPerPageOptions={[7, 14, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <Dialog
        open={view}
        aria-labelledby="form-dialog-title"
        scroll="body"
        maxWidth="md"
        fullWidth
      >
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
          </Grid>
            <Grid item>
              <DialogTitle>{/* {urlVideo} */}</DialogTitle>
              <Button
                onClick={handleClose}
                color="primary"
                size="large"
              >
                <ClearOutlinedIcon />
              </Button>
            </Grid>
          </Grid>
          <DialogContent style={{height: 500}}>
          
          <video controls autoplay width="900" height="460">
              <source src={ urlVideo} type="video/webm" />
          </video>
          
          </DialogContent> 
        </Dialog>
    </div>
  );
}
